<template>
    <div class="title" :class="`${border?'hasBorder':''}`">
        <span>{{num}}</span>
        <span>{{text}}</span>
    </div>
</template>
<script>
export default {
    props:{
        text:{
            default:''
        },
        num:{
            default:1
        },
        border:{
            default:false
        }
    }
}
</script>
<style lang="scss" scoped>
    .title{
        display: flex;
        align-items: center;
        padding-left: 55px;
        margin-bottom: 24px;
        position: relative;
        &>span:first-child{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            background: #F77B0B;
            font-size: 18px;
            color: #fff;
            font-weight: bold;
            box-shadow: 3px 3px 0px #f7790b9d;
        }
        &>span:last-child{
            margin-left: 11px;
            font-size: 18px;
            font-weight: bold;
            color: #606266;
        }
    }
    .title.hasBorder{
        padding-top: 60px;
    }
    .title.hasBorder:before{
        content:'';
        display: block;
        position: absolute;
        left: 0;
        top: 20px;
        width: 100%;
        border-top: 1px solid #E5E5E5;
    }
</style>


// WEBPACK FOOTER //
// src/views/userCenter/companyCertificate/components/publicTitle.vue